export enum Campaign {
  LIVELO = 'livelo',
}
